import { getFormattedProductWeight } from '../../utils';
import { IFinance } from '@monofront/types';
import { useTranslations } from 'next-intl';

export const useFormatProductWeight = () => {
  const tCatalog = useTranslations('Catalog');

  const formatProductWeight = (
    finance: IFinance | undefined,
    isShortFormat = true,
  ) => {
    const { formattedWeight, drainedWeightTranslationKey } =
      getFormattedProductWeight(finance, isShortFormat);
    const drainedWeight = drainedWeightTranslationKey
      ? tCatalog(drainedWeightTranslationKey as any) // @todo: move global intl declarations to the project root
      : '';

    return formattedWeight ? `${formattedWeight} ${drainedWeight}` : '';
  };

  return { formatProductWeight };
};
